<template>
  <div class="item-sacola" id="btn-delete-info">
    <div class="item-sacola">
      <div class="info-product-image">
        <img :src="item.item.url" />
      </div>
      <div class="info-product">
        <p class="title">{{ item.item.nome }}</p>
        <p>Tamanho: {{ item.item.tamanho }}</p>
      </div>
      <div class="info-product-taken">
        <p>Quantidade: {{ item.qntSelecionado }}</p>
        <p>
          Valor unitário:
          <b
            >R$
            {{ item.item.preco.preco_venda.toFixed(2).replace(".", ",") }}</b
          >
        </p>
      </div>
      <div class="info-product-finalprice">
        <p>Total</p>
        <p>
          <b>
            R$
            {{
              (item.qntSelecionado * item.item.preco.preco_venda)
                .toFixed(2)
                .replace(".", ",")
            }}
          </b>
        </p>
      </div>

      <!-- <div v-if="none" id="itens">
      <th id="image_sacola"></th>
      <th id="name_sacola"></th>
      <th id="price_qnt_sacola">Quantidade</th>
      <th id="price_qnt_sacola">Preço</th>
    </div>
    <div v-else id="itens">
      <th id="image_sacola">
        <img :src="item.item.url" id="imagem_sacola" />
      </th>
      <th id="name_sacola">{{ item.item.nome }}</th>
      <th id="price_qnt_sacola">
        <div>
          <p>{{ item.qntSelecionado }}</p>
          <button v-on:click="execute">Excluir</button>
        </div>
      </th>
      <th id="price_qnt_sacola">
        R$
        {{
        (item.qntSelecionado * item.item.preco.preco_venda)
        .toFixed(2)
        .replace(".", ",")
        }}
      </th>
    </div> -->
    </div>
    <div class="product-delete" @click="execute">
      <span class="material-icons"> close </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProdutosSacola",
  props: {
    none: Object,
    item: Object,
    sacola: Object,
    deleteItem: {
      type: Function,
    },
  },
  methods: {
    deleteData() {
      let sac = this.sacola;
      let new_sacola = sac.filter((e) => e.item._id !== this.item.item._id);

      //this.sacola = new_sacola;
      const sav = JSON.stringify(new_sacola);
      localStorage.setItem("sacola", sav);
    },
    execute() {
      if (this.deleteItem) {
        this.deleteItem(this.item);
      }
    },
  },
};
</script>

<style>
.item-sacola {
  display: flex;
  background-color: #fff;
  padding: 20px;
  text-align: left;
  font-size: 14px;
}

.item-sacola p {
  margin-top: 5px;
  text-transform: capitalize;
  margin-bottom: 5px;
}

.item-sacola .product-delete {
  width: 50px;
  cursor: pointer;
}

.item-sacola .info-product-finalprice,
.item-sacola .info-product-taken {
  align-self: flex-end;
}

.item-sacola .info-product-finalprice {
  text-align: right;
}

.item-sacola .info-product-image {
  max-width: 100px;
  height: 100px;
}

.item-sacola .info-product {
  margin-left: 20px;
}

.item-sacola .info-product .title {
  font-weight: bold;
}

#itens {
  justify-self: center;
}

#qnt_itens_prod_sac {
  text-align: center;
}

#name_sacola {
  width: 80%;
}

#image_sacola {
  width: 100px;
}

#price_qnt_sacola {
  width: 10%;
  text-align: center;

  height: auto;
  align-items: center;
  align-self: center;
  align-content: center;
  justify-items: center;
  justify-content: center;
  justify-self: center;
}

#price_qnt_sacola button {
  text-decoration-line: underline;
  margin-top: 10px;
}

#imagem_sacola {
  height: auto;
  width: 100px;
}

@media screen and (max-width: 800px) {
  .item-sacola {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    padding: 20px;
    text-align: left;
    font-size: 14px;
  }

  #btn-delete-info {
    display: flex;
    flex-direction: row;
  }

  .item-sacola .info-product {
    margin-left: 0px;
    margin-top: 40px;
  }
}
</style>
